import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IMAGEM_LOGO_SIMBOLO_REPUBLICA_BASE64 } from '../../../../../../app.constants';
import { CnpjPipe } from '../../../../pipe/cnpj-pipe';
import { CpfPipe } from '../../../../pipe/cpf-pipe';
import { DeclRendWebModel } from '../../../../models/declRendWeb.model';
import { PessoaJuridicaModel } from '../../../../models/pessoa-juridica.model';
import { InformacoesIndividuaisDeclaRenda } from '../../../../dominios/DTO/informacoes-individuais-decla-renda';
import { PessoaDadosSimplicadosModel } from '../../../../models/pessoa-simplificada.model';
import { FormateNumberZeroPipe } from '../../../../pipe/format-number-zero.pipe';

@Injectable()
export class DeclaracaoRendimentoPdf {

    constructor(
        private _decimalPipe: DecimalPipe,
        private _formateNumberZeroPipe: FormateNumberZeroPipe,
        private _cpf: CpfPipe,
        private _cnpj: CnpjPipe
    ) { }

    public funcionarios(pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel, declRendWebModel: DeclRendWebModel, anoAtual: number, ano: number,
        pessoaJuridicaModel: PessoaJuridicaModel, informacoesIndividuaisDeclaRenda: InformacoesIndividuaisDeclaRenda,
        versaoRetorno: number, informacoesComplementoTela: string) {

        const doc = new jsPDF('p', 'mm', 'a4');

        if (!declRendWebModel.nrProcAcum) {
            declRendWebModel.nrProcAcum = ''
        }
        if (!declRendWebModel.dsNaturezaAcum) {
            declRendWebModel.dsNaturezaAcum = ''
        }

        doc.autoTable({
            theme: 'grid',
            columnStyles: {
                contentB: { halign: 'center', fontSize: 9, fontStyle: 'bold' },
                contentC: { halign: 'center', fontSize: 9, fontStyle: 'bold' },
            },
            styles: {
                lineColor: [0, 0, 0],
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            body: [{
                contentA: `                `,
                contentB: `Ministério da Fazenda \n Secretaria da Receita Federal do Brasil \n Imposto sobre a Renda da Pessoa Física \n Exercício de ${anoAtual} `,
                contentC: `Comprovante de Rendimentos\n Pagos e de Imposto\n sobre a Renda Retido na Fonte \n Ano-calendário de ${ano}`
            }],
            didDrawCell: function (data) {
                if (
                    (data.row.section === 'body') &&
                    data.column.dataKey === 'contentA'
                ) {
                    doc.addImage(
                        IMAGEM_LOGO_SIMBOLO_REPUBLICA_BASE64,
                        'PNG',
                        data.cell.x + 5,
                        data.cell.y + 1,
                        15,
                        15
                    )
                }
            },
        });


        doc.setFontSize(8);
        doc.text('1. Fonte Pagadora Pessoa Jurídica ou Pessoa Física', 14, doc.previousAutoTable.finalY + 6)
        doc.autoTable({
            theme: 'grid',
            columnStyles: {
                contentA: { fontSize: 9, fontStyle: 'bold' },
                contentB: { fontSize: 9, fontStyle: 'bold' }
            },
            styles: {
                cellPadding: 0.5,
                lineColor: [0, 0, 0],
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            body: [{
                contentA: `CNPJ /CPF: \n ${this._cnpj.transform(pessoaJuridicaModel.cnpj)}`,
                contentB: `Nome Empresarial / Nome Completo: \n ${pessoaJuridicaModel.nome}`
            }]
        });

        doc.setFontSize(8);
        doc.text('2. Pessoa Física Beneficiária dos Rendimentos', 14, doc.autoTable.previous.finalY + 6)
        doc.autoTable({
            theme: 'grid',
            styles: {
                margin: { top: 100 }, cellPadding: 0.5,
                lineColor: [0, 0, 0],
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            margin: { top: 100 },
            body: [
                [{ content: `CPF: ${this._cpf.transform(pessoaDadosSimplicadosModel.cpf)} `, styles: { fillColor: [235, 243, 249], fontSize: 9, fontStyle: 'bold' } },
                { content: `Nome Completo: ${pessoaDadosSimplicadosModel.nome}  `, styles: { fillColor: [235, 243, 249], fontSize: 9, fontStyle: 'bold' } }],
                [{ content: `Natureza do Rendimento: ${declRendWebModel.dsNatureza}`, colSpan: 2, styles: { fontSize: 9 } }]
            ],
        });

        doc.setFontSize(8);
        doc.text('3. Rendimentos Tributáveis, Deduções e Imposto sobre a Renda Retido na Fonte Valores em reais', 14, doc.previousAutoTable.finalY + 6)
        doc.text('Valores em reais', 170, doc.previousAutoTable.finalY + 6)
        doc.autoTable({
            theme: 'grid',
            columnStyles: {
                contentA: { fontSize: 9 },
                contentB: { fontSize: 9, halign: 'right', cellWidth: 30 }
            },
            styles: {
                cellPadding: 0.5,
                lineColor: [0, 0, 0],
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            body: [
                {
                    contentA: `1. Total dos rendimentos (inclusive férias)`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlRendimentos, '1.2-2'))}`
                },
                {
                    contentA: `2. Contribuição previdenciária oficial`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlInss, '1.2-2'))}`
                },
                {
                    contentA: `3. Contribuição a entidades de previdência complementar e a fundos de aposentadoria prog. \n individual (Fapi) (preencher também o quadro 7)`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlPrevPrivada, '1.2-2'))}`
                },
                {
                    contentA: `4. Pensão alimentícia (preencher também o quadro 7)`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlPensAlim, '1.2-2'))}`
                },
                {
                    contentA: `5. Imposto sobre a renda retido na fonte`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlIrrf, '1.2-2'))}`
                },
            ],
        });


        doc.setFontSize(8);
        doc.text('4. Rendimentos Isentos e Não Tributáveis Valores em reais', 14, doc.previousAutoTable.finalY + 6)
        doc.text('Valores em reais', 170, doc.previousAutoTable.finalY + 6)
        doc.autoTable({
            theme: 'grid',
            columnStyles: {
                contentA: { fontSize: 9 },
                contentB: { fontSize: 9, halign: 'right', cellWidth: 30 }
            },
            styles: {
                cellPadding: 0.5,
                lineColor: [0, 0, 0],
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            body: [
                {
                    contentA: `1. Parcela isenta dos proventos de aposentadoria, reserva remunerada,\n reforma e pensão (65 anos ou mais)`
                    , contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vl65anos, '1.2-2'))}`
                },
                {
                    contentA: `2. Parcela isenta do 13º salário de aposentadoria, remunerada, \n reforma e pensão (65 anos ou mais)`
                    , contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlIsento13, '1.2-2'))}`
                },
                {
                    contentA: `3. Diárias e ajudas de custo`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlDiarias, '1.2-2'))}`
                },
                {
                    contentA: `4. Pensão e proventos de aposentadoria ou reforma por moléstia grave;\n proventos de aposentadoria ou reforma por acidente em serviço`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlAposent, '1.2-2'))}`
                },
                {
                    contentA: `5. Lucros e dividendos, apurados a partir de 1996, pagos por pessoa jurídica\n (lucro real, presumido ou arbitrado)`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlLucros, '1.2-2'))}`
                },
                {
                    contentA: `6. Valores pagos ao titular ou sócio da microempresa ou empresa de pequeno porte, exceto pro labore,\n aluguéis ou serviços prestados`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlSocioMe, '1.2-2'))}`
                },
                {
                    contentA: `7. Indenizações por rescisão de contrato de trabalho,\n inclusive a título de PDV e por acidente de trabalho`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlRescisao, '1.2-2'))}`
                },
                {
                    contentA: `8. Juros de mora recebidos, devidos pelo atraso no pagamento de remuneração por exercício de emprego, cargo ou função`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlJurosMora, '1.2-2'))}`
                },
                {
                    contentA: `9. Outros ` + declRendWebModel.dsOutros  ,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlOutros, '1.2-2'))}`
                },
            ],
        });


        doc.setFontSize(8);
        doc.text('5. Rendimentos Sujeitos à Tributação Exclusiva (rendimento líquido) Valores em reais', 14, doc.previousAutoTable.finalY + 6)
        doc.text('Valores em reais', 170, doc.previousAutoTable.finalY + 6)
        doc.autoTable({
            theme: 'grid',
            columnStyles: {
                contentA: { fontSize: 9 },
                contentB: { fontSize: 9, halign: 'right', cellWidth: 30 }
            },
            styles: {
                cellPadding: 0.5,
                lineColor: [0, 0, 0],
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            body: this._bodyRowsRendimentosSujeitosTributacaoExclusiva(ano, declRendWebModel),
        });

        if (ano >= 2011) {
            doc.setFontSize(8);
            doc.text('6. Rendimentos Recebidos Acumuladamente – Art. 12-A da Lei nº 7.713, de 1988 (sujeitos à tributação exclusiva)', 14, doc.previousAutoTable.finalY + 6)
            doc.autoTable({
                theme: 'grid',
                styles: {
                    cellPadding: 0.5,
                    lineColor: [0, 0, 0],
                    lineWidth: 0.1,
                    textColor: [0, 0, 0]
                },
                body: [
                    [
                        { content: `6.1 Número do processo:  ${declRendWebModel.nrProcAcum}             `, styles: { fontSize: 9 } },
                        { content: `Quantidade de meses: `, styles: { fontSize: 9 } },
                        { content: `   ${declRendWebModel.qtMesesAcum}`, styles: { fontSize: 9, cellWidth: 30, halign: 'right' } }
                    ],
                    [{ content: `Natureza do Rendimento:  ${declRendWebModel.dsNaturezaAcum}`, colSpan: 4, styles: { fontSize: 9 } }]
                ],
            });
        }

        if (ano >= 2014) {
            doc.autoTable({
                theme: 'grid',
                columnStyles: {
                    contentA: { fontSize: 9 },
                    contentB: { fontSize: 9, halign: 'right', cellWidth: 30 }
                },
                styles: {
                    cellPadding: 0.5,
                    lineColor: [0, 0, 0],
                    lineWidth: 0.1,
                    textColor: [0, 0, 0]
                },
                body: [
                    {
                        contentA: `1. Total dos rendimentos tributáveis (inclusive férias e décimo terceiro salário)`,
                        contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlRendAcum, '1.2-2'))}`
                    },
                    {
                        contentA: `2. Exclusão: Despesas com a ação judicial`,
                        contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlDespesaAcum, '1.2-2'))}`
                    },
                    {
                        contentA: `3. Dedução: Contribuição previdenciária oficial`,
                        contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlContribAcum, '1.2-2'))}`
                    },
                    {
                        contentA: `4. Dedução: Pensão alimentícia (preencher também o quadro 7)                                               `,
                        contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlPensaoAcum, '1.2-2'))}`
                    },
                    {
                        contentA: `5. Imposto sobre a renda retido na fonte`,
                        contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlIrAcum, '1.2-2'))}`
                    },
                    {
                        contentA: `6. Rendimentos isentos de pensão, proventos de aposentadoria ou reforma por moléstia \n grave ou aposentadoria ou reforma por acidente em serviço`,
                        contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlIsentoAcum, '1.2-2'))}`
                    },
                ],
            });
        }

        doc.setFontSize(8);

        (ano >= 2011) ?
            doc.text('7. Informações Complementares', 14, doc.previousAutoTable.finalY + 6)
            : doc.text('6. Informações Complementares', 14, doc.previousAutoTable.finalY + 6)

        doc.autoTable({
            theme: 'plain',
            columnStyles: { 0: { fontSize: 7 }, halign: 'left' },
            styles: {
                cellPadding: 0.1,
                lineColor: [0, 0, 0],
                lineWidth: 0.1,
                textColor: [0, 0, 0],
                fontSize: 7
            },
            body: [[informacoesComplementoTela.trim()]]
        });



        doc.setFontSize(8);

        (ano >= 2011) ?
            doc.text('8. Responsável pelas informações', 14, doc.previousAutoTable.finalY + 6)
            : doc.text('8. Responsável pelas informações', 14, doc.previousAutoTable.finalY + 6)

        doc.autoTable({
            theme: 'grid',
            styles: {
                cellPadding: 0.5,
                lineColor: [0, 0, 0],
                lineWidth: 0.1,
                textColor: [0, 0, 0]
            },
            body: [
                [{ content: `Nome:  ${informacoesIndividuaisDeclaRenda.nomeResponsavel}             `, styles: { fontSize: 9 } },
                { content: `Data: ${informacoesIndividuaisDeclaRenda.dataRespon}            `, styles: { fontSize: 9 } },
                { content: `Assinatura:          `, styles: { fontSize: 9 } }]
            ],
        });

        doc.setFontSize(5);
        doc.text('Aprovado pela IN RFB nr. 1.682, de 28 de dezembro de 2016.', 14, doc.previousAutoTable.finalY + 2)
        doc.text(`                     Impresso em ${this.dataAtualFormatada()}`, 100, doc.previousAutoTable.finalY + 2)
        doc.text(`  versão: ${versaoRetorno}`, 185, doc.previousAutoTable.finalY + 2)

        doc.setProperties({
            title: 'Declaração',
            subject: `Declaração gerado em ${new Date('dd/mm/yyy')} `,
            author: 'centrus',
            keywords: 'generated, javascript, web 2.0, ajax',
            creator: 'Fundação Banco central de previcência provida - centrus'
        });

        (window.innerWidth > 640)
            ? (window.open(URL.createObjectURL(doc.output('blob'))))
            : this.handleFile(doc.output('blob'), 'declaracao.pdf');
    }

    handleFile(res: any, fileName: string) {
        const file = new Blob([res], {
            type: res.type
        });

        // IE
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
            return;
        }



        const blob = window.URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = blob;
        link.download = fileName;

        // link.click();
        link.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        }));

        setTimeout(() => { // firefox
            window.URL.revokeObjectURL(blob);
            link.remove();
        }, 100);
    }


    private _bodyRowsRendimentosSujeitosTributacaoExclusiva(ano: number, declRendWebModel: DeclRendWebModel) {
        const body = []

        if (ano > 2014) {

            body.push(
                {
                    contentA: `1. Décimo terceiro salário`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vl13Sal, '1.2-2'))}`
                },
                {
                    contentA: `2. Imposto sobre a renda retido na fonte sobre 13º salário                                                                   `,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlIr13, '1.2-2'))}`

                },
                {
                    contentA: `3. Outros  ` ,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlOutrosExcl, '1.2-2'))}`
                })

        } else {
            body.push(
                {
                    contentA: `1. Décimo terceiro salário`,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vl13Sal, '1.2-2'))}`
                },
                {
                    contentA: `2. Outros                                                                   `,
                    contentB: `${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declRendWebModel.vlOutrosExcl, '1.2-2'))}`

                })
        }

        return body;
    }


    dataAtualFormatada() {
        const data = new Date(),
            dia = data.getDate().toString(),
            diaF = (dia.length === 1) ? '0' + dia : dia,
            mes = (data.getMonth() + 1).toString(),
            mesF = (mes.length === 1) ? '0' + mes : mes,
            anoF = data.getFullYear(),
            hora = data.getHours(),
            minuto = data.getMinutes(),
            segundos = data.getSeconds();
        return diaF + '/' + mesF + '/' + anoF + ' ' + hora + ':' + minuto + ':' + segundos;
    }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/documentos-pdf-imprimir/financeiro/declaracao-redimento/declaracao-rendimento-pdf.ts